/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { Document, Font, Image, Page, StyleSheet, Text, View } from '@react-pdf/renderer'
import Roboto from '../../../../../assets/fonts/Roboto-Bold.ttf'
import { CriterioResponse, DescricaoCargo, iAssinaturas } from '../../../../../interfaces'
import { formatarDataHora } from '../../../utils/data'
import Logo from '../../assets/LogoSah.png'

interface iProps {
  cargo: DescricaoCargo
  criterios: CriterioResponse[]
  assinaturas?: iAssinaturas[]
}

Font.register({
  family: 'Roboto',
  fonts: [{
    src: Roboto
  }]
})

const styles = StyleSheet.create({
  page: {
    paddingBottom: 48,
    paddingTop: 12
  },
  body: {
    paddingHorizontal: 24
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 20,
    paddingHorizontal: 24,
    paddingBottom: 16,
    borderBottom: '2px solid #66046B'
  },
  headerTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    fontFamily: 'Roboto',
    textAlign: 'center'
  },
  sectionTitle: {
    fontSize: 12,
    fontWeight: 'bold',
    fontFamily: 'Roboto',
    textAlign: 'center'
  },
  boxInformacoes: {
    borderBottom: '1px solid #000',
    paddingHorizontal: 12,
    paddingVertical: 6,
    minHeight: 34,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  },
  paragraph: {
    fontSize: 10
  },
  itemList: {
    marginLeft: 12,
    marginBottom: 4
  },
  bullet: {
    fontSize: 10,
    marginLeft: 6
  },
  criteriaBlock: {
    marginTop: 12
  }
})

function getBoxGrupos(cargo: DescricaoCargo, titulo: string, propriedade: 'conhecimentosTecnicos' | 'habilidades' | 'atribuicoes' | 'competenciasComportamentais'): any {
  // Nada aqui pode ser flexDirection: row: o react-pdf so sabe quebrar pagina em conteudo
  // empilhado em coluna, entao uma linha (rotulo | conteudo) nunca se divide entre paginas -
  // ela pula inteira pra proxima, deixando um vazio enorme quando o conteudo e grande. Por isso
  // o rotulo do nivel vira uma faixa acima do conteudo, tudo em coluna, e o texto flui normalmente
  return <View style={{ border: '1px solid #000', display: 'flex', flexDirection: 'column', marginTop: 16 }}>
    <View style={{ justifyContent: 'center', backgroundColor: '#C9C9C9', paddingVertical: '6px', borderBottom: '1px solid #000' }}>
      <Text style={{ ...styles.sectionTitle, fontSize: '11px' }}>{titulo}</Text>
    </View>
    {Object.entries(cargo.niveis).map(([key, nivel], index) => {
      const artigo = (propriedade === 'conhecimentosTecnicos') ? 'o' : 'a'
      const ultimo = index === (Object.entries(cargo.niveis).length - 1)

      return <View style={{ display: 'flex', flexDirection: 'column', borderBottom: ultimo ? 'none' : '1px solid #000' }}>
      <View
        minPresenceAhead={20}
        style={{
          display: 'flex',
          backgroundColor: '#F0F0F0',
          paddingVertical: 4,
          paddingHorizontal: 18,
          borderBottom: '1px solid #000'
        }}
      >
        <Text style={{ fontWeight: 'bold', fontFamily: 'Roboto', fontSize: 10 }}>{key}</Text>
      </View>
      <View
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '4px',
          backgroundColor: '#FFFFFF',
          paddingHorizontal: 18,
          paddingVertical: 12
        }}
      >
        {index > 0 && (
          <Text style={{ fontSize: 9 }}>Tod{artigo}s {artigo}s {propriedade === 'conhecimentosTecnicos' ? 'conhecimentos técnicos' : 'atribuições'} do nível anterior e...</Text>
        )}
        {nivel[propriedade].map(val => { return <Text style={{ fontSize: 9, textAlign: 'justify' }}>• {val}</Text> })}
      </View>
    </View>
    })}
  </View>
}

function getBoxCriterios(cargo: DescricaoCargo, titulo: string, criterios: CriterioResponse[]): any {
  return <View style={{ border: '1px solid #000', display: 'flex', flexDirection: 'column', marginTop: 16 }}>
    <View style={{ justifyContent: 'center', backgroundColor: '#C9C9C9', paddingVertical: '6px', borderBottom: '1px solid #000' }}>
      <Text style={{ ...styles.sectionTitle, fontSize: '11px' }}>{titulo}</Text>
    </View>
    {criterios.map((c, index) => {
      return <View style={{ display: 'flex', flexDirection: 'row' }} wrap={false}>
        <View
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: '16%',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#F0F0F0',
            borderRight: '1px solid #000',
            borderBottom: (index === (criterios.length - 1)) ? 'none' : '1px solid #000'
          }}
        >
          <Text style={{ fontWeight: 'bold', fontFamily: 'Roboto', fontSize: 9, textAlign: 'center' }}>{c.nomeCriterio}</Text>
        </View>
        <View style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '4px',
          width: '84%',
          paddingHorizontal: 18,
          paddingVertical: 12,
          backgroundColor: '#FFFFFF',
          borderBottom: (index === (criterios.length - 1)) ? 'none' : '1px solid #000'
        }}>
          {Object.entries(cargo.niveis).map(([key, nivel]) => {
            const nivelOp = nivel.criteriosPontuacao.find(e => e.criterioId === c.id)
            const opcao = c.niveis.find(n => n.id === nivelOp?.opcaoPontuacaoId)
            return <View
              style={{ display: 'flex', flexDirection: 'row', gap: '6px', maxWidth: 375 }}
            >
              <Text style={{ fontFamily: 'Roboto', fontWeight: 'bold', fontSize: 9, textAlign: 'justify' }}>{key}:</Text>
              <Text style={{ fontSize: 9, textAlign: 'justify' }}>{opcao?.nome}</Text>
            </View>
          })}
        </View>
      </View>
    })}
  </View>
}

function getBoxVerificacaoAssinaturas(cargo: DescricaoCargo, assinaturas: iAssinaturas[]): any {
  // Quem virou desatualizado assinou uma versao anterior, entao a assinatura nao vale mais
  const assinadasBrutas = assinaturas.filter(a =>
    a.assinado && cargo.assinantes?.some(assinante => assinante.email === a.emailAssinante && assinante.status === 2)
  )

  // Reassinar (ex: SAH e depois localhost em teste) gera mais de um registro para o mesmo
  // email: so a assinatura mais recente e a valida, o resto e ruido no PDF
  const maisRecentePorEmail = new Map<string, iAssinaturas>()

  assinadasBrutas.forEach((a) => {
    const atual = maisRecentePorEmail.get(a.emailAssinante)

    if (atual === undefined || new Date(a.assinadoEm ?? 0) > new Date(atual.assinadoEm ?? 0)) {
      maisRecentePorEmail.set(a.emailAssinante, a)
    }
  })

  const assinadas = Array.from(maisRecentePorEmail.values())

  if (assinadas.length === 0) return null

  return <View style={{ border: '1px solid #000', display: 'flex', flexDirection: 'column', marginTop: 16 }} wrap={false}>
    <View style={{ justifyContent: 'center', backgroundColor: '#D6D6D6', paddingVertical: '6px', borderBottom: '1px solid #000' }}>
      <Text style={{ ...styles.sectionTitle, fontSize: '11px' }}>VERIFICAÇÃO DE ASSINATURAS</Text>
    </View>
    {assinadas.map((assinatura, index) => (
      <View
        key={assinatura.id}
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '2px',
          paddingHorizontal: 12,
          paddingVertical: 8,
          borderBottom: (index === (assinadas.length - 1)) ? 'none' : '1px solid #000'
        }}
      >
        <Text style={{ fontSize: 9 }}>
          <Text style={{ fontFamily: 'Roboto', fontWeight: 'bold' }}>ID: </Text>{assinatura.id}
        </Text>
        <Text style={{ fontSize: 9 }}>
          <Text style={{ fontFamily: 'Roboto', fontWeight: 'bold' }}>Nome: </Text>{assinatura.nomeAssinante}
        </Text>
        <Text style={{ fontSize: 9 }}>
          <Text style={{ fontFamily: 'Roboto', fontWeight: 'bold' }}>Data: </Text>{formatarDataHora(assinatura.assinadoEm) ?? 'Não informada'}
        </Text>
      </View>
    ))}
  </View>
}

const DescricaoCargoPDF = ({ cargo, criterios, assinaturas }: iProps) => (
  <Document>
    <Page size="A4" style={styles.page} wrap>
      <View style={styles.header} fixed>
        <View style={{ width: '100px' }}>
          <Image src={Logo} style={{ objectFit: 'contain', maxHeight: 40, maxWidth: '100px' }} />
        </View>
        <View style={{ display: 'flex', flexDirection: 'column', gap: '2px', alignItems: 'center' }}>
          <Text style={{ ...styles.headerTitle, fontSize: '13px', fontFamily: 'Helvetica' }}>{cargo.nomeEmpresa}</Text>
          <Text style={{ ...styles.headerTitle }}>{cargo.nomeCargo}</Text>
        </View>
        <View style={{ width: '100px' }}>
          <Image src={cargo.logoEmpresa ?? Logo} style={{ objectFit: 'contain', maxHeight: 40, maxWidth: '100px' }} />
        </View>
      </View>
      <View
        fixed
        style={{
          position: 'absolute',
          bottom: 0,
          textAlign: 'center',
          fontSize: 9,
          backgroundColor: '#66046B',
          paddingVertical: 4,
          alignItems: 'center',
          justifyContent: 'space-between',
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
          gap: 32
        }}
      >
        <View style={{ width: '15%' }}></View>
        <View style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
            <Text style={{ fontSize: '9px', fontFamily: 'Roboto', fontWeight: 'bold', color: 'white' }}>DESCRIÇÃO DE CARGO E FUNÇÃO: {cargo.nomeCargo}</Text>
        </View>
        <View style={{ width: '15%' }}>
          <Image
              style={{
                height: 22,
                objectFit: 'contain'
              }}
              source="https://sigah.blob.core.windows.net/onboard/0acc742b-1a78-4d9e-9bfd-26b6c1f46c19.png"
          />
        </View>
      </View>

      <View style={styles.body}>
        <View style={{ border: '1px solid #000', display: 'flex', flexDirection: 'column' }}>
          <View style={{ justifyContent: 'center', backgroundColor: '#D6D6D6', paddingVertical: '6px', borderBottom: '1px solid #000' }}>
            <Text style={styles.sectionTitle}>IDENTIFICAÇÃO</Text>
          </View>
          <View style={{ display: 'flex', flexDirection: 'row', backgroundColor: '#FFFFFF' }}>
            <View
              style={{
                borderRight: '1px solid #000',
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                alignItems: 'center'
              }}
            >
              <View style={styles.boxInformacoes}>
                <Text style={{ ...styles.paragraph, fontWeight: 'bold', fontFamily: 'Roboto', fontSize: 9 }}>Título do cargo:</Text>
                <Text style={styles.paragraph}>{cargo.nomeCargo}</Text>
              </View>

              <View style={styles.boxInformacoes}>
                <Text style={{ ...styles.paragraph, fontWeight: 'bold', fontFamily: 'Roboto', fontSize: 9 }}>Área:</Text>
                <Text style={styles.paragraph}>{cargo.areaNome}</Text>
              </View>

              <View style={{ ...styles.boxInformacoes, borderBottom: 'none' }}>
                <Text style={{ ...styles.paragraph, fontWeight: 'bold', fontFamily: 'Roboto', fontSize: 9, borderBottom: 'none' }}>CBO:</Text>
                <Text style={styles.paragraph}>{cargo.cbo}</Text>
              </View>
            </View>
            <View
              style={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                justifyContent: 'center',
                alignItems: 'center'
              }}
            >
              <View style={styles.boxInformacoes}>
                <Text style={{ ...styles.paragraph, fontWeight: 'bold', fontFamily: 'Roboto', fontSize: 9 }}>Hierarquia:</Text>
                <Text style={styles.paragraph}>{cargo.nivelHierarquico}</Text>
              </View>

              <View style={styles.boxInformacoes}>
                <Text style={{ ...styles.paragraph, fontWeight: 'bold', fontFamily: 'Roboto', fontSize: 9 }}>Atuação:</Text>
                <Text style={styles.paragraph}>{cargo.atuacao}</Text>
              </View>
                <View
                style={{ ...styles.boxInformacoes, borderBottom: 'none' }}
                >
                <Text style={{ ...styles.paragraph, fontWeight: 'bold', fontFamily: 'Roboto', fontSize: 9, marginBottom: 2 }}>Cargos superiores:</Text>
                {cargo.cargosSuperiores && cargo.cargosSuperiores?.length > 0
                  ? (
                      cargo.cargosSuperiores.map((cs, index) => (
                      <Text key={index} style={{ ...styles.paragraph, fontFamily: 'Roboto', fontSize: 9, borderBottom: 'none', paddingBottom: 0 }}>
                        {cs.nome === '' ? ('Ninguém (topo da hierarquia)') : (cs.nome)}
                      </Text>
                      )
                      ))
                  : (
                    <Text style={{ fontWeight: 'bold', fontFamily: 'Roboto', fontSize: 9, borderBottom: 'none', paddingBottom: 0 }}>
                          Ninguém (Topo da hierarquia)
                    </Text>
                    )
                }
              </View>
            </View>
          </View>
          <View style={{ display: 'flex', flexDirection: 'row', backgroundColor: '#FFFFFF', borderTop: '1px solid #000' }}>
            <View
              style={{
                borderRight: '1px solid #000',
                display: 'flex',
                flexDirection: 'column',
                width: '100%'
              }}
            >
              <View style={{ ...styles.boxInformacoes, borderBottom: 'none', gap: '2px' }}>
                {Object.keys(cargo.cargosFuturos).length === 0 && (
                    <Text style={{ ...styles.paragraph, fontWeight: 'bold', fontFamily: 'Roboto', fontSize: 9, borderBottom: 'none' }}>
                      Nenhuma trilha de carreira disponível
                    </Text>
                )}
                {Object.entries(cargo.cargosFuturos)
                  .map(([trilha, cargos], index) => (
                    <Text key={index} style={{ ...styles.paragraph, fontWeight: 'bold', fontFamily: 'Roboto', fontSize: 9, borderBottom: 'none', paddingBottom: 0 }}>
                      {trilha}: {cargos.map(c => c.nome).join(' → ')}
                    </Text>
                  ))}
              </View>
            </View>
            <View
              style={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%'
              }}
            >
              <View style={{ ...styles.boxInformacoes, borderBottom: 'none', gap: '2px' }}>
                <Text style={{ ...styles.paragraph, fontWeight: 'bold', fontFamily: 'Roboto', fontSize: 9, marginBottom: 2 }}>Cargos subordinados:</Text>
                {cargo.cargosSubordinados && cargo.cargosSubordinados.length > 0
                  ? (
                      cargo.cargosSubordinados.map((cs, index) => (
                      <Text key={index} style={{ ...styles.paragraph, fontFamily: 'Roboto', fontSize: 9, borderBottom: 'none', paddingBottom: 0 }}>
                        {cs.nome}
                      </Text>
                      ))
                    )
                  : (
                    <Text style={{ ...styles.paragraph, fontFamily: 'Roboto', fontSize: 9, borderBottom: 'none', paddingBottom: 0 }}>
                      Ninguém (nenhum cargo subordinado)
                    </Text>
                    )
                }
              </View>
            </View>
          </View>
        </View>

        <View style={{ border: '1px solid #000', display: 'flex', flexDirection: 'column', marginTop: 16 }}>
          <View style={{ justifyContent: 'center', backgroundColor: '#D6D6D6', paddingVertical: '6px', borderBottom: '1px solid #000' }}>
            <Text style={styles.sectionTitle}>Missão</Text>
          </View>
          <View style={{ display: 'flex', flexDirection: 'row', backgroundColor: '#FFFFFF' }}>
            <View
              style={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                alignItems: 'center'
              }}
            >
              <View style={{ ...styles.boxInformacoes, borderBottom: 'none' }}>
                <Text style={styles.paragraph}>{cargo.missao}</Text>
              </View>
            </View>
          </View>
        </View>

        {getBoxGrupos(cargo, 'ATRIBUIÇÕES DA FUNÇÃO', 'atribuicoes')}

        {getBoxGrupos(cargo, 'CONHECIMENTOS TÉCNICOS DESEJÁVEIS', 'conhecimentosTecnicos')}

        {/* {getBoxGrupos(cargo, 'HABILIDADES DESEJÁVEIS', 'habilidades')} */}

        <View style={{ border: '1px solid #000', display: 'flex', flexDirection: 'column', marginTop: 16 }}>
          <View style={{ justifyContent: 'center', backgroundColor: '#C9C9C9', paddingVertical: '6px', borderBottom: '1px solid #000' }}>
            <Text style={{ ...styles.sectionTitle, fontSize: '11px' }}>REQUISITOS COMPORTAMENTAIS DESEJÁVEIS</Text>
          </View>
          <View style={{
            flexDirection: 'row',
            flexWrap: 'wrap',
            paddingHorizontal: 18,
            paddingVertical: 12
          }} >
            {(cargo.competenciasComportamentais).map((nivel, index) => {
              return <Text style={{ fontSize: 9, textAlign: 'justify' }}>• {nivel}; </Text>
            })}
          </View>
        </View>

        {getBoxCriterios(cargo, 'CRITÉRIOS', criterios)}

        <View wrap={false} style={{ border: '1px solid #000', display: 'flex', flexDirection: 'column', marginTop: 16 }}>
          <View style={{ justifyContent: 'center', backgroundColor: '#C9C9C9', paddingVertical: '6px', borderBottom: '1px solid #000' }}>
            <Text style={{ ...styles.sectionTitle, fontSize: '11px' }}>PONTUAÇÃO</Text>
          </View>
          {Object.entries(cargo.niveis).map(([key, nivel], index) => {
            return <View style={{ display: 'flex', flexDirection: 'row' }}>
            <View
              style={{
                display: 'flex',
                flexDirection: 'column',
                width: '16%',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#F0F0F0',
                borderRight: '1px solid #000',
                borderBottom: (index === (Object.entries(cargo.niveis).length - 1)) ? 'none' : '1px solid #000'
              }}
            >
              <Text style={{ fontWeight: 'bold', fontFamily: 'Roboto', fontSize: 10 }}>{key}</Text>
            </View>
            <View
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '4px',
                width: '84%',
                backgroundColor: '#FFFFFF',
                paddingHorizontal: 18,
                paddingVertical: 12,
                borderBottom: (index === (Object.entries(cargo.niveis).length - 1)) ? 'none' : '1px solid #000'
              }}
            >
              <Text style={{ fontSize: 9, textAlign: 'justify' }}>{nivel.criteriosPontuacao
                ?.map(cp => {
                  const crit = criterios.find(c => c.id === cp.criterioId)
                  const opcao = crit?.niveis.find(n => n.id === cp.opcaoPontuacaoId)
                  return opcao?.pontuacao ?? 0
                })
                .reduce((acc, val) => acc + val, 0)
              }</Text>
            </View>
          </View>
          })}
        </View>
        {getBoxVerificacaoAssinaturas(cargo, assinaturas ?? [])}
        {cargo.assinadoPor && <View style={{ justifyContent: 'center', marginTop: '14px', display: 'flex', flexDirection: 'row', gap: '4px' }}>
          <Text style={{ ...styles.sectionTitle, fontSize: '9px' }}>Aprovado por:</Text>
          <Text style={{ ...styles.sectionTitle, fontSize: '9px', textDecoration: 'underline' }}>{cargo.assinadoPor}</Text>
        </View>}
      </View>
    </Page>
  </Document>
)

export default DescricaoCargoPDF
